<template>
    <div class="d-flex flex-column flex-lg-row align-items-center filter-services">
        <p>TIPO DE ENFERMEDAD</p>
        <ul class="align-items-center position-relative mw-100" id="scrollbar">
            <li v-for="item in categories"
                :key="item.id">
                <button @click="searchCategory(item.id)"
                    :class="category === item.id ? 'active' : ''">
                    {{ item.title }}
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'FilterCategory',
    props: {
        categories: {
            type: Array,
            default: ()=>[],
        },
        category: {
            type: Number,
            default: 0,
        }
    },
    methods: {
        searchCategory(id){
            this.$emit(`filterById`, id);
        }
    }
}
</script>
